import { StepperModel } from 'components/General/Stepper'
import Photos from 'components/Inventory/Creation/Photos'
import Price from 'components/Inventory/Creation/Price'
import Provider from 'components/Inventory/Creation/Provider'
import Summary from 'components/Inventory/Creation/Summary'
import GeneralInformation from 'components/Inventory/Creation/VehicleInformation/GeneralInformation'
import VehicleDetail from 'components/Inventory/Creation/VehicleInformation/VehicleDetail'
import VehicleFeatures from 'components/Inventory/Creation/VehicleInformation/VehicleFeatures'
import VehicleMeasurements from 'components/Inventory/Creation/VehicleInformation/VehicleMeasurements'
import VehiclePower from 'components/Inventory/Creation/VehicleInformation/VehiclePower'
import VehicleSpacing from 'components/Inventory/Creation/VehicleInformation/VehicleSpacing'

import { Option } from 'models/Select'
import { BaseEntity } from 'models/services/base'
import {
  InventoryColor,
  VehicleInformationSelectOptions,
} from 'models/services/inventory/detail'
import {
  VehicleCreationAction,
  VehicleCreationDataType,
} from 'models/services/PreInventory/creation'
import { ExtendedStatus } from 'models/services/status'
import { StepperTextType } from 'models/text/General'

export type VehicleCreationProps = {
  handleBack: () => void
  handleContinue: () => void
  handleSecondaryBack: () => void
  handleSecondaryContinue: () => void
  currentSecondaryStep: number
  vehicleData: VehicleCreationDataType
  updateVehicleData: (action: VehicleCreationAction) => void
  brands: BaseEntity[]
  statusList: ExtendedStatus[]
  vehicleSelectOptions: VehicleInformationSelectOptions
  colorList: InventoryColor[]
  countryVersionList: Option[]
}

export const INITIAL_VEHICLE_CREATION_STEPS: Array<
  React.FC<VehicleCreationProps>
> = [
  GeneralInformation,
  VehicleDetail,
  VehicleFeatures,
  VehicleSpacing,
  VehicleMeasurements,
  VehiclePower,
]

export const INITIAL_VEHICLE_MAIN_STEPS: Array<React.FC<VehicleCreationProps>> =
  [GeneralInformation, Provider, Price, Photos, Summary]

export const createVehicleStepperItems = (
  text: Partial<StepperTextType>
): StepperModel[] => {
  const stepperItems: StepperModel[] = [
    {
      label: text.firstStep as string,
      hasPercentage: true,
      totalSubSteps: 6,
    },
    { label: text.secondStep as string },
    {
      label: text.thirdStep as string,
    },
    {
      label: text.fourthStep as string,
    },
    {
      label: text.fifthStep as string,
    },
  ]

  return stepperItems
}

export const createSecondaryVehicleStepperItems = (
  text: Partial<StepperTextType>
): StepperModel[] => {
  const stepperItems: StepperModel[] = [
    {
      label: text.firstStep as string,
    },
    { label: text.secondStep as string },
    {
      label: text.thirdStep as string,
    },
    {
      label: text.fourthStep as string,
    },
    {
      label: text.fifthStep as string,
    },
  ]

  return stepperItems
}

export const categoriesWidth = (width: number) => {
  if (width && width > 1734) {
    return '1200px'
  }
  if (width && width > 1374) {
    return '890px'
  }
  return '590px'
}
